import { FC, useEffect, useState } from 'react';
import { Routes, Route, BrowserRouter, Navigate, HashRouter } from 'react-router-dom';
import { PrivateRoutes } from './PrivateRoutes';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { Logout, AuthPage } from '../modules/auth';
import { App } from '../App';



const AppRoutes: FC = () => {
  const [auth, setAuth] = useState(false);

  useEffect(() => {
    // Check auth state on mount and when localStorage changes
    const checkAuth = () => {
      const token = localStorage.getItem('loginToken');
      setAuth(!!token);
    };

    checkAuth();

    // Listen for storage events (for multi-tab sync)
    window.addEventListener('storage', checkAuth);

    // Custom event for same-tab localStorage changes
    window.addEventListener('login', checkAuth);
    window.addEventListener('logout', checkAuth);

    return () => {
      window.removeEventListener('storage', checkAuth);
      window.removeEventListener('login', checkAuth);
      window.removeEventListener('logout', checkAuth);
    };
  }, []);





  return (
    <HashRouter basename={''}>
      <Routes>
           <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {auth ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </HashRouter>
  );
};

export { AppRoutes };
